// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"tablaPersonal__headerRow___1zvyx","evenRow":"tablaPersonal__evenRow___jIrwm","oddRow":"tablaPersonal__oddRow___2h7UL","headerColumn":"tablaPersonal__headerColumn___3nXPd","headerRowAPI":"tablaPersonal__headerRowAPI___1IlFM","evenRowAPI":"tablaPersonal__evenRowAPI___1tg_k","oddRowAPI":"tablaPersonal__oddRowAPI___1x-ve","headerColumnAPI":"tablaPersonal__headerColumnAPI___2weNY","celdaAPI":"tablaPersonal__celdaAPI___3bcQL","celdaAPILider":"tablaPersonal__celdaAPILider___2bdxt"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/MantenedorPersonal/tablaPersonal.css
// module id = 716
// module chunks = 0